import Chip from "@material-ui/core/Chip";
import React from "react";
import UserReferenceResponse from "../../../../api/models/UserReferenceResponse";
import {
  UsersSearchMultipleAutocomplete, //
} from "../../../../components/Autocomplete/CustomSearchAutoComplete.instances";
import StyledTooltip from "../../../../components/Wrapper/StyledTooltip";

interface CustomTagProps {
  data: Required<UserReferenceResponse>;
  disabled: boolean;
  onDelete: () => void;
}

const CustomTag: React.FC<CustomTagProps> = ({
  data,
  disabled,
  onDelete,
  // ! separate unwanted tagProps (disabled, onDelete) to avoid undesired behavior
  ...restTagProps
}) => {
  return (
    <StyledTooltip title={data.userEmail || ""} {...restTagProps}>
      <Chip label={data.userName} />
    </StyledTooltip>
  );
};

interface SalesTeamInputProps {
  values: Required<UserReferenceResponse>[];
}

const SalesTeamInput: React.FC<SalesTeamInputProps> = ({ values }) => {
  return (
    <UsersSearchMultipleAutocomplete
      disabled
      customTag={CustomTag}
      inputLabel="Sales Team"
      map={(data): { key: string; label: string } => ({
        key: data.userEmail,
        label: data.userName,
      })}
      onChange={() => {}}
      optionFetch={() => {
        return Promise.resolve({
          data: [] as Required<UserReferenceResponse>[],
          totalPages: 0,
        });
      }}
      tagColorSecondary={() => true}
      value={values}
    />
  );
};

export default SalesTeamInput;
